import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Form as FinalForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import { ValidationErrors } from 'final-form'

import Button from '../../../control/button/button'
import useTranslate from '../../../i18n/useTranslate'
import { IconButton } from '@material-ui/core'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

type FormParam = {
    email: string
    password: string
    confirmPassword: string
}
interface FormProps {
    onClickSubmit: (values: FormParam) => void
    onClickShowPassword: () => void
    onClickShowPasswordCf: () => void
    isShowPassword: boolean
    isShowPasswordCf: boolean
    email?: string
}

const Form: FC<FormProps> = ({
    onClickSubmit,
    onClickShowPassword,
    onClickShowPasswordCf,
    isShowPassword,
    isShowPasswordCf,
    email,
}) => {
    const classes = useStyles()
    const t = useTranslate()

    const validateForm = (values: FormParam) => {
        const errors: ValidationErrors = {}

        if (values.password && values.confirmPassword) {
            if (values.confirmPassword !== values.password) {
                errors.confirmPassword = t.get('MESSAGE.M019')
            }
        }

        return errors
    }

    return (
        <Grid container>
            <Grid item xs={12} className={classes.title}>
                <Typography variant={'h6'} className={classes.typo}>
                    {t.get('UM.ACTIVATE.HEADER')}
                </Typography>
            </Grid>
            <FinalForm onSubmit={onClickSubmit} initialValues={{ email }} validate={validateForm}>
                {({ handleSubmit, form }) => {
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="email"
                                    materialInputProps={{
                                        disabled: true,
                                        label: `${t.get('UM.ACTIVATE.EMAIL')}`,
                                        placeholder: `${t.get('UM.ACTIVATE.EMAIL')}`,
                                        size: 'medium',
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="password"
                                    type={isShowPassword ? 'text' : 'password'}
                                    materialInputProps={{
                                        disabled: false,
                                        label: `${t.get('UM.ACTIVATE.PASSWORD')}`,
                                        placeholder: `${t.get('UM.ACTIVATE.PASSWORD')}`,
                                        size: 'medium',
                                    }}
                                    icon={
                                        <IconButton size="small" onClick={onClickShowPassword}>
                                            {isShowPassword ? (
                                                <Visibility style={{ fontSize: '1.2rem' }} />
                                            ) : (
                                                <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                            )}
                                        </IconButton>
                                    }
                                    required
                                    handleValueChange={(val: string) => {
                                        if (val) {
                                            const txt = val.replace(/[ก-๙]|\s/g, '')
                                            form.change('password', txt)
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="confirmPassword"
                                    type={isShowPasswordCf ? 'text' : 'password'}
                                    materialInputProps={{
                                        disabled: false,
                                        label: `${t.get('UM.ACTIVATE.CONFIRM_PASSWORD')}`,
                                        placeholder: `${t.get('UM.ACTIVATE.CONFIRM_PASSWORD')}`,
                                        size: 'medium',
                                    }}
                                    icon={
                                        <IconButton size="small" onClick={onClickShowPasswordCf}>
                                            {isShowPasswordCf ? (
                                                <Visibility style={{ fontSize: '1.2rem' }} />
                                            ) : (
                                                <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                            )}
                                        </IconButton>
                                    }
                                    required
                                    handleValueChange={(val: string) => {
                                        if (val) {
                                            const txt = val.replace(/[ก-๙]|\s/g, '')
                                            form.change('confirmPassword', txt)
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" style={{ justifyContent: 'flex-end' }}>
                                    <Grid item style={{ float: 'right' }}>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {t.get('UM.ACTIVATE.OK')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    title: {
        margin: '16px 0px',
    },
    root: {
        width: '667px',
        padding: '48px',
    },
    typo: {
        fontWeight: 'bold',
    },
}))

export default Form
